import { useState } from 'react';
import { getTimeWithTimeZone, downloadLocalFile } from 'utility/general';
import CustomLink from 'components/CustomLink';
import { GET_DOWNLOAD_DOCUMENT, SET_PROTOCOL_DEVIATION_REPORT } from 'store/key';
import { useDispatch, useSelector } from 'react-redux';
import API from 'api/call';

const useUploadDocData = ({ protocolDeviationReport, rows }) => {

    console.log('%c 155229 useUploadDocData.js rows', 'background: green', rows)

    const dispatch = useDispatch();
    const user = useSelector((state) => state.user);

    const getDownloadDocument = (row, type) => {
        const canDownloadServerFile = protocolDeviationReport?.remoteDocIds?.includes(row.id);
        if (canDownloadServerFile) {
            dispatch({
                type: GET_DOWNLOAD_DOCUMENT,
                payload: {
                    data: {
                        id: row.id,
                    },
                    apiUrl: API.protocolDeviationReport.downloadDocument,
                },
            });
        } else {
            downloadLocalFile(row.tempFile);
        }
    };

    const getFileNameContent = (params) => {
        let fileName = params.getValue('fileName');
        return (
            <CustomLink isStopJumping isChangeColor onClick={() => getDownloadDocument(params.row)}>
                {fileName}
            </CustomLink>
        );
    };

    const defaultUploadDocFormList = {
        fileName: {
            alignItems: 'baseline',
            value: [],
            label: 'File Name',
            name: 'fileName',
            type: 'uploadFile',
            multiple: true,
            validators: ['isRequired'],
            enableRemove: true,
        },
    };

    const columns = [
        {
            field: 'createDtm',
            headerName: 'Upload Date',
            width: 200,
            valueGetter: (params) => {
                let date = params.getValue('createDtm');
                date = date ? getTimeWithTimeZone(date).format('YYYY-MM-DD') : '-';
                return date;
            },
        },
        { field: 'createdBy', headerName: 'Uploaded By', width: 200 },
        {
            field: 'fileName',
            headerName: 'File',
            width: 300,
            valueGetter: (params) => getFileNameContent(params),
        },
    ];

    const [showUploadDocDialog, setShowUploadDocDialog] = useState(false);

    const handleUploadDocUpdate = (row) => {
        const { firstName, surname } = user?.detail;

        let newData = [];
        const newRows = row.fileName.map((item, index) => {
            newData.push(item.key);
            return {
                id: item.key,
                uploadTempId: item.key,
                createDtm: new Date(),
                createdBy: surname + ' ' + firstName,
                fileName: item.name,
                tempFile: item.tempFile,
            };
        });

        dispatch({
            type: SET_PROTOCOL_DEVIATION_REPORT,
            payload: {
                rows: [...rows, ...newRows],
                remoteDetail: {
                    ...protocolDeviationReport.remoteDetail,
                    addSupplements: [...protocolDeviationReport.remoteDetail.addSupplements, ...newData],
                },
            },
        });
    };

    const handleUploadDocDelete = (row) => {

        console.log('%c 154816 useUploadDocData.js row', 'background: green', row)

        const index = rows.findIndex((item) => item.id === row.id);
        let copyRows = [...rows];
        copyRows.splice(index, 1);

        let deleteSupplements = protocolDeviationReport.remoteDetail.deleteSupplements;
        let addSupplements = protocolDeviationReport.remoteDetail.addSupplements;
        if (protocolDeviationReport?.remoteDocIds?.includes(row.id)) {
            deleteSupplements.push(row.id);
        }

        if (addSupplements?.includes(row.id)) {
            const index = addSupplements.findIndex((i) => i === row.id);
            addSupplements.splice(index, 1);
        }

        dispatch({
            type: SET_PROTOCOL_DEVIATION_REPORT,
            payload: {
                rows: copyRows,
                remoteDetail: {
                    ...protocolDeviationReport.remoteDetail,
                    deleteSupplements,
                    addSupplements,
                },
            },
        });
    };

    return {
        columns,
        defaultUploadDocFormList,
        showUploadDocDialog,
        setShowUploadDocDialog,
        handleUploadDocUpdate,
        handleUploadDocDelete,
    };
};
export default useUploadDocData;
